import { useEffect, useState } from "react";
import { DataTable } from "primereact/datatable";
import useUserStore from "../../utils/storeApp";
import { Column } from "primereact/column";
import { useNavigate, Link } from "react-router-dom";
import $ from "jquery";
import CallAPI from "../../services/apiCalls";
import DetailsOrgEmails from "./DetailsOrgEmails";
import UserEmailList from "../users/UserEmailList";
import { Dropdown } from "primereact/dropdown";
import { MdnDispatchMode } from "../../utils/enums";

let o = {
  OrganizationId: "",
  Email: "",
  SearchBy: "",
  FromDate: "",
  ToDate: "",
  UserName: "",
  Name: "",
};

const ListEmails = () => {
  const {
    userRole,
    userToken,
    SetSharedObject,
    sharedObject,
    XdrArr,
    setXDRArr,
    userSession,
  } = useUserStore((state) => ({
    userRole: state.userRole,
    userToken: state.userToken,
    SetSharedObject: state.SetSharedObject,
    sharedObject: state.sharedObject,
    XdrArr: state.XdrArr,
    setXDRArr: state.setXDRArr,
    userSession: state.userSession,
  }));
  const [emailListObj, setEmailListObj] = useState([]);
  const [showGridFlag, SetShowGridFlag] = useState(false);
  const navigate = useNavigate();
  const [addBtnFlag, setAddBtnFlag] = useState(false);
  const [processing, setProcessing] = useState(false);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [customerCustVal, setCustomerCustVal] = useState(null);
  const [orgObj, SetOrgObj] = useState([]);
  const [customerOrgVal, setCustomerOrgVal] = useState(null);
  const [customerObj, SetCustomerObj] = useState([]);
  const [customerCustValSearch, setCustomerCustValSearch] = useState(null);
  const [orgObjSearch, SetOrgObjSearch] = useState([]);
  const [customerOrgValSearch, setCustomerOrgValSearch] = useState(false);
  const [customerObjSearch, SetCustomerObjSearch] = useState([]);
  const [answers, setAnswers] = useState(o);
  const [detailsEmail, setdetailsEmail] = useState({});
  const [showBackBtn, SetShowBackBtn] = useState(false);
  const [custFlag, SetCustFlag] = useState(false);
  const [errDetailFlag, SetErrDetailFlag] = useState(false);
  const [errDetailMsg, SetErrDetailsMsg] = useState(false);
  const [cmfMessage, SetCmfMessage] = useState(
    "Are you sure you want to delete email(s)?",
  );
  const [cmfFlag, SetCmfFlag] = useState(false);
  const [reasonInput, setReasonInput] = useState("");
  const [submitFlag, setSubmitFlag] = useState(false);
  const [sbmitFlag, setSbmitFlag] = useState(false);
  const [searchEmail, setSearchEmail] = useState("");
  const [orgId, setOrgId] = useState(false);
  const [processingDelete, setprocessingDelete] = useState(false);
  const [deleteFlag, setDeleteFlag] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const setAnswer = (questionId, answer) => {
    setAnswers({ ...answers, [questionId]: answer });
  };

  const getXDREndPoints = async () => {
    setProcessing(true);
    SetErrDetailFlag(false);
    let call = "/organization/getAllXDREndPoints";
    const res = await CallAPI(call, false, "get", userToken);
    SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      setXDRArr(res.data.data);
    } else if (res.status === "SERVERERROR") {
      SetErrDetailsMsg("An error occurred. Please contact your administrator");
      SetErrDetailFlag(true);
    }
    setProcessing(false);
  };

  const getOrgIdEmailsList = async (mdl) => {
    setProcessing(true);
    SetErrDetailFlag(false);
    let call = "";
    if (mdl.Flag === "orgEmails") {
      call = "/organization/GetDirectEmails?orgId=" + mdl.Id;
    } else {
      call = "/emails/GetUsersDirectEmails?userId=" + mdl.Id;
    }
    const res = await CallAPI(call, false, "post", userToken);
    SetSharedObject("ResponseCode", res.code);

    if (res.status === "SUCCESS") {
      setProcessing(false);
      setAddBtnFlag(true);
      let tempObj = [];
      for (const row of res.data.data) {
        row.CustomerId = customerCustVal;
        row.FlagType = "emailLIst";
        row.organizationId = mdl.Id;

        if (mdl.Flag === "orgEmails") {
          row.id = row.directEmailId;
          row.emailType = "orgEmails";
          row.userId = 0;
        } else {
          row.emailType = "userEmails";
        }

        let cs = (
          <button
           type="button"
            className="btn btn-link border-0 align-baseline font-weight-bold"
            onClick={(el) => {
              emailType(row, "show");
              el.preventDefault();
            }}
            aria-label={`View details for ${row.directEmailAddress || "this email"}`}
          >
            {row.directEmailAddress}
          </button>
        );
        row.dtCreated = new Date(row.dateCreated);
        row.date = new Date(row.dateCreated);
        row.GridLinkCourse = cs;
        row.keepMdn = row.keepMDN ? "YES" : "NO";
        row.directEmailPurpose =
          row.directEmailPurposeId === 0 || row.emailPurposeId === 0
            ? "General"
            : row.directEmailPurposeId === 1 || row.emailPurposeId === 1
              ? "Medical RecordsXML only"
              : row.directEmailPurposeId === 2 || row.emailPurposeId === 2
                ? "Medical Records"
                : "Administrative";
        let es = (
          <button
            type="button"
            className="btn btn-link border-0 align-baseline font-weight-bold"
            onClick={(el) => {
              emailTypeName(row, "show");
              el.preventDefault();
            }}
            aria-label={`View details for emails ${row.name || "this email"}`}
          >
            {row.name}
          </button>
        );
        row.EmailDirect = es;
        row.name = mdl.Name;

        if (row.userEmailTypeString !== "Shared") {
          tempObj.push(row);
        }
      }

      if (tempObj.length > 0) {
        CloseAdvSearch();
      }

      SetSharedObject("emailListObj", tempObj);
    } else if (res.status === "SERVERERROR") {
      SetErrDetailsMsg("An error occurred. Please contact your administrator");
      SetErrDetailFlag(true);
    }
    setProcessing(false);
  };

  useEffect(() => {
    setAddBtnFlag(false);
    SetSharedObject("emailsSharing", []);
    SetCustomerObj(sharedObject.vendorsObj);

    const temp = [];
    if (sharedObject?.vendorsObj?.length > 0) {
      for (let el of sharedObject.vendorsObj) {
        el.show = true;
        temp.push(el);
      }
    }

    SetCustomerObjSearch(temp);
    let obj = sharedObject.UserIdEmail;

    if (Object.keys(obj).length > 0 && obj.constructor === Object) {
      setAddBtnFlag(true);
      SetShowGridFlag(true);
      SetCustFlag(true);
      getOrgIdEmailsList(obj);
    }

    if (
      userRole !== "SES ADMINISTRATOR" &&
      userRole !== "SYSTEMADMINISTRATOR"
    ) {
      OrgSearchEngine(userSession.vendor_id);
      SetSharedObject("reloadEmailList", false);
    }

    getXDREndPoints();
  }, [sharedObject.reloadEmailList]);

  const OrgSearchEngine = async (id) => {
    let obj = { VendorId: id };
    setProcessing(true);

    let call = "/organization/OrgSearchEngine";
    const res = await CallAPI(call, obj, "post", userToken);
    SetSharedObject("ResponseCode", res.code);

    if (res.status === "SUCCESS") {
      let dt = res.data.data;
      const temp = [];
      for (let el of dt) {
        el.show = true;
        temp.push(el);
      }
      SetOrgObjSearch(temp);
      SetOrgObj(temp);
      setProcessing(false);
    }
  };

  const GetXdrConfig = async (vl) => {
    let tempXDR = {};
    if (vl) {
      for (let el of XdrArr) {
        if (el.id === parseInt(vl)) {
          tempXDR = el;
          break;
        }
      }
    }

    SetSharedObject("orgXDRObj", tempXDR);
    SetSharedObject("xdrSettiingObj", tempXDR);
  };

  const getEmailsList = async (mdl, check, userEmails) => {
    setProcessing(true);
    SetErrDetailFlag(false);
    if (check) {
      await getOrgDetails(mdl.OrganizationId);
    }

    let call = "";
    let obj = null;

    if (userEmails) {
      call = "/emails/GetUserEmails?SesUserId=" + parseInt(mdl.UserId);
      obj = false;
    } else {
      obj = mdl;
      call = "/emails/SearchEmails";
    }
    const res = await CallAPI(call, obj, "post", userToken);
    SetSharedObject("ResponseCode", res.code);
    setProcessing(false);
    if (res.status === "SUCCESS") {
      setProcessing(false);
      let tempObj = [];

      for (const row of res.data.data) {
        row.CustomerId = customerCustVal;
        row.FlagType = "orgLIst";
        let cs = (
            <button 
            type="button"
            className="btn btn-link border-0 align-baseline font-weight-bold"
            onClick={(el) => {
              emailType(row, "show");
              el.preventDefault();
            }}
            aria-label={`View details for ${row.directEmailAddress || "this email"}`}
          >
            {row.directEmailAddress}
          </button>
        );

        row.dtCreated = new Date(row.dateCreated);
        row.GridLinkCourse = cs;
        row.date = new Date(row.dateCreated);
        row.keepMdn = row.isKeepMDN ? "YES" : "NO";
        row.directEmailPurpose =
          row.directEmailPurposeId === 0
            ? "General"
            : row.directEmailPurposeId === 1
              ? "Medical RecordsXML only"
              : row.directEmailPurposeId === 2
                ? "Medical Records"
                : "Administrative";
        let es = (
          <button
            type="button"
            className="btn btn-link border-0 align-baseline font-weight-bold"
            onClick={(el) => {
              emailTypeName(row, "show");
              el.preventDefault();
            }}
            aria-label={
              row.emailType === "Organization"
                ? `Go to organization: ${row.name}`
                : `Go to user: ${row.name}`
            }
          >
            {row.name}
          </button>
        );
        row.userEmailTypeString = row.emailType;
        row.EmailDirect = es;
        tempObj.push(row);
      }

      if (tempObj.length > 0) {
        CloseAdvSearch();
        SetShowGridFlag(true);
      }
      SetSharedObject("emailListObj", tempObj);
    } else if (res.status === "SERVERERROR") {
      SetErrDetailsMsg("An error occurred. Please contact your administrator");
      SetErrDetailFlag(true);
    }
  };

  const getOrgDetails = async (id) => {
    SetSharedObject("orgXDRObj", {});
    SetSharedObject("orgDetails", {});
    setProcessing(true);

    let call = "/emails/GetOrgDetails?OrganizationId=" + parseInt(id);
    const res = await CallAPI(call, false, "get", userToken);

    SetSharedObject("ResponseCode", res.code);
    setProcessing(false);
    if (res.status === "SUCCESS") {
      GetXdrConfig(res.data.data.xdrConfig.id);
      SetSharedObject("orgDetails", res.data.data);
      SetSharedObject("orgActionObj", res.data.data);
    } else if (res.status === "SERVERERROR") {
      let msg = res.data;
      let str = "<div>";
      for (let el of msg) {
        str += `${el}`;
      }
      str += "</div>";

      SetErrDetailsMsg(str);
      SetErrDetailFlag(true);
    }

    setProcessing(false);
  };

  const emailType = async (row) => {
    setSelectedProducts([row]);
    setProcessing(true);
    SetErrDetailFlag(false);
    setdetailsEmail({
      ...row,
      orgXDR: sharedObject.orgXDRObj,
      orgDetails: sharedObject.orgDetails,
    });

    if (row.emailType === "User" || row.emailType === "userEmails") {
      let call =
        "/emails/GetUserDirectEmails?directEmailId=" +
        parseInt(row.directEmailId) +
        "&UserId=" +
        row.userId;

      const res = await CallAPI(call, false, "get", userToken);
      SetSharedObject("ResponseCode", res.code);

      if (res.status === "SUCCESS") {
        SetSharedObject("emailsForwarding", res.data.data.emailForwards);
        await setdetailsEmail({
          ...row,
          emailForwording: res.data.data.emailForwards,
        });
      } else if (res.status === "SERVERERROR") {
        let msg = res.data;
        let str = "<div>";
        for (let el of msg) {
          str += `${el}`;
        }
        str += "</div>";
        SetErrDetailsMsg(str);
        SetErrDetailFlag(true);
      }
    } else {
      let call =
        "/emails/GetUserSharedEmails?DirectEmail=" + row.directEmailAddress;

      const res = await CallAPI(call, false, "get", userToken);
      SetSharedObject("ResponseCode", res.code);

      if (res.status === "SUCCESS") {
        SetSharedObject("emailsSharing", res.data.data);
        setdetailsEmail({
          ...row,
          emailSharing: res.data.data,
        });
      } else if (res.status === "SERVERERROR") {
        SetErrDetailsMsg(
          "An error occurred. Please contact your administrator",
        );
        SetErrDetailFlag(true);
      }
    }

    setProcessing(false);
    $("#detailsEmailOrgModal").modal("show");
  };

  const emailTypeName = async (row) => {
    if (row.emailType === "Organization") {
      navigate("/organizations");
    } else {
      setProcessing(false);
      navigate("/users");
    }
  };

  const CustomerIdSet = async (el) => {
    setCustomerCustVal(el);

    if (el === "") {
      SetOrgObj([]);
      return;
    }

    customerObjSearch.map((elx) => {
      if (elx.id === parseInt(el))
        SetSharedObject("CustomerPermissionsObj", elx);
    });

    setAddBtnFlag(false);
    SetShowGridFlag(false);
    let obj = sharedObject.getOrgsObj;
    let temp = [];
    if (obj) {
      for (let elem of obj) {
        if (parseInt(el) === elem.vendorId) {
          temp.push(elem);
        }
      }
    }
    SetOrgObj(temp);
  };

  const CustomerIdSetSearch = async (el) => {
    setCustomerCustValSearch(el);

    if (el === "") {
      SetOrgObjSearch([]);
      return;
    }

    customerObjSearch.map((elx) => {
      if (elx.id === parseInt(el))
        SetSharedObject("CustomerPermissionsObj", elx);
    });

    setProcessing(true);

    let call = "/users/GetOrgsByCustID?vendorID=" + parseInt(el);
    const res = await CallAPI(call, false, "get", userToken);

    SetSharedObject("ResponseCode", res.code);

    if (res.status === "SUCCESS") {
      const temp = [];
      for (let el of res.data.data) {
        el.show = true;
        temp.push(el);
      }
      SetOrgObjSearch(temp);
    } else if (res.status === "SERVERERROR") {
      let msg = res.data;
      let str = "<div>";
      for (let el of msg) {
        str += `${el}`;
      }
      str += "</div>";
      SetErrDetailsMsg(str);
      SetErrDetailFlag(true);
    }
    setProcessing(false);
  };

  const SelectUsersByOrgId = async (vl) => {
    SetSharedObject("orgDetails", {});
    SetSharedObject("UserIdEmail", {});
    setCustomerOrgVal(vl);
    let val = vl.split(",");
    let orgId = val[0];
    setOrgId(orgId);
    SetShowGridFlag(true);
    let src = {};
    src.OrganizationId = parseInt(orgId);
    getEmailsList(src, true);
  };

  const [orgIdSearch, setOrgIdSearch] = useState(false);

  const SelectUsersByOrgIdSearch = async (vl) => {
    SetCustFlag(false);
    SetShowBackBtn(false);
    setCustomerOrgValSearch(vl);
    let val = vl.split(",");
    let orgId = val[0];
    setOrgIdSearch(orgId);
    setAnswer("OrganizationId", orgId);
  };

  const SearchWithEnter = (e) => {
    if (e.key === "Enter") {
      SearchByEmail();
    }
  };

  const SearchByEmail = async () => {
    SetCustFlag(false);
    SetShowBackBtn(false);
    if (searchEmail === "") {
      return;
    }
    let src = {};
    //src.OrganizationId = orgId;
    src.Email = searchEmail;
    getEmailsList(src, false);
  };

  const filterVendors = (val) => {
    const tmp = [];
    if (val.length > 1) {
      customerObjSearch?.map((el) => {
        let elem = el.name;
        if (elem.toLowerCase().includes(val.toLowerCase())) {
          el.show = true;
        } else {
          el.show = false;
        }
        tmp.push(el);
      });
    } else {
      customerObjSearch?.map((el) => {
        el.show = true;
        tmp.push(el);
      });
    }
    SetCustomerObjSearch(tmp);
  };

  const filterOrgs = (val) => {
    const tmp = [];
    if (val.length > 1) {
      orgObjSearch?.map((el) => {
        let elem = el.name;
        if (elem.toLowerCase().includes(val.toLowerCase())) {
          el.show = true;
        } else {
          el.show = false;
        }
        tmp.push(el);
      });
    } else {
      orgObjSearch?.map((el) => {
        el.show = true;
        tmp.push(el);
      });
    }
    SetOrgObjSearch(tmp);
  };

  const handleDateChange = (field, val) => {
  // If val is an object (datepicker Date object), convert it to a locale string.
  // If it's already a string or empty, use it directly.
  const cleaned =
    val && typeof val === "object"
      ? val.toLocaleDateString("en-US")
      : val ?? "";
  setAnswer(field, cleaned);
};

  const AdvSearch = () => {
    setSubmitFlag(true);
    SetCustFlag(false);
    SetShowBackBtn(false);
    if (answers.OrganizationId === "") return;
    SetShowGridFlag(true);
    const payload = {
    ...answers,
    // Send null instead of empty string so the API ignores the field
    FromDate: answers.FromDate || null,
    ToDate: answers.ToDate || null,
  };

  getEmailsList(payload, true);
  };

  const showParent = (flag) => {
    if (flag) {
      if (sharedObject.UserIdEmail.Navigate === "orgEmails") {
        navigate("/organizations");
      } else if (sharedObject.UserIdEmail.Navigate === "Users") {
        navigate("/users");
      }
    }
  };

  const emailRefresh = (detailsEmail) => {
    let src = {};
    src.OrganizationId = parseInt(detailsEmail.organizationId, false);
    if (detailsEmail.FlagType === "orgLIst") {
      getEmailsList(src, true);
    } else {
      getOrgIdEmailsList(detailsEmail, true);
    }
  };

  const DeleteEmailComfirm = async () => {
    SetCmfFlag(0);
    setDeleteFlag(false);
    if (selectedProducts.length === 0) {
      SetCmfMessage("Please select an email.");
      SetCmfFlag(1);
      return;
    } else {
      if (reasonInput === "") {
        setSbmitFlag(true);
        return;
      }
      await DeleteEmails();
    }
  };

  const DeleteEmails = async () => {
    SetCmfMessage("");
    setprocessingDelete(true);
    setDeleteFlag(false);

    for (const el of selectedProducts) {
      let orgId = el.organizationId ? el.organizationId : 0;
      let call =
        "/emails/DeleteUserDirectEmail?emailType=" +
        el.userEmailTypeString +
        "&directEmailId=" +
        el.directEmailId +
        "&userId=" +
        el.userId +
        "&directEmailAddress=" +
        el.directEmailAddress +
        "&orgId=" +
        orgId +
        "&reason=" +
        reasonInput;

      const res = await CallAPI(call, false, "post", userToken);
      SetSharedObject("ResponseCode", res.code);

      if (res.status === "SUCCESS") {
        if (res.data.data?.errorList?.messages?.length > 0) {
          let msg = res.data.data.errorList?.messages;
          let str = "<div>";
          for (let el of msg) {
            str += `${el}`;
          }
          str += "</div>";
          SetCmfMessage(str);
          SetCmfFlag(1);
        } else {
          /*   $("#comfirmDelete").modal("hide");*/
          setSelectedProducts([]);
          setDeleteFlag(true);
        }
      } else if (res.status === "SERVERERROR") {
        let msg = res.data;
        let str = "<div>";
        if (msg === "") {
          str += `System Error. Please contact your Administrator.`;
        } else {
          for (let el of msg) {
            str += `${el}`;
          }
        }
        str += "</div>";
        SetCmfMessage(str);
        SetCmfFlag(1);
      }
    }

    if (cmfFlag !== 1) {
      if (custFlag) {
        let obj = sharedObject.UserIdEmail;
        getOrgIdEmailsList(obj, true, true);
      } else {
        let src = {};
        src.OrganizationId = parseInt(orgId);
        getEmailsList(src, false);
      }
    }

    setprocessingDelete(false);
  };

  const createdDate = (dt) => {
    return dt.dateCreated
      ? new Date(dt.dateCreated).toLocaleString("en-US", { hour12: false })
      : null;
  };

  const ServDesc = (dt) => {
    let val = dt.directTrustServiceDescriptionCode;
    const obj = sharedObject?.getServDesc;
    let servDesc = "";
    for (let i = 0; i < obj.length; i++) {
      if (obj[i].code === val) {
        return obj[i].display;
      }
    }
    return servDesc;
  };
  const MdnDispatchModeDisplay = (dt) => {
    switch (dt.mdnDispatchMode) {
      case MdnDispatchMode.Conditional:
        return "Conditional";
      case MdnDispatchMode.AlwaysSend:
        return "Always Send";
      default:
        return "";
    }
  };

  const [loadingText, setLoadingText] = useState("Loading...");
  useEffect(() => {
    let timer;
    if (processing) {
      timer = setTimeout(() => {
        setLoadingText("Working on it...");
      }, 10000);
    } else {
      setLoadingText("Loading...");
    }

    return () => clearTimeout(timer);
  }, [processing]);


  const closeModal = (modalId) => {
    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }
    $(`#${modalId}`).modal("hide");

  };

  const CloseAdvSearch = () => closeModal("advEmailSearchModal");
  const CloseDeleteModal = () => {
    setDeleteFlag(false);
    $(".modal").modal("hide");
  };

  return (
    <main className="ListEmails" >
      <div className="HeaderEmailTools">
        <header className="ht-6">
          <div className="spacer-inline sp-margin12">
            {showBackBtn ||
            (custFlag &&
              sharedObject.UserIdEmail.Navigate &&
              sharedObject.UserIdEmail.Navigate !== "detailUser") ? (
              <div className="spacer-inline btnback-container-1">
                <button className="btn btn-outline-secondary btnback sp-pad0"
                aria-label="Go back to previous page"
                  onClick={(el) => {
                    showParent(custFlag);
                    el.preventDefault();
                  }}
                >
                  <i className="bi bi-arrow-left-square-fill" aria-hidden="true"></i>
                </button>
              </div>
            ) : null}
            <h4 className="title-label3">
              {sharedObject.UserIdEmail?.Navigate === "orgEmails"
                ? `Emails for Org: ${sharedObject.UserIdEmail.Name}`
                : sharedObject.UserIdEmail?.Navigate === "detailUser"
                  ? `Emails for User: ${sharedObject.UserIdEmail.Name}`
                  : "List"}
            </h4>
          </div>

          <div className="mid-header-bar">
          {/*Search by name*/}
            <div className="spacer-inline spacer-margin5">
              <div className="input-group">
                <input
                  type="search"
                  className="form-control"
                  id="searchByEmail"
                  name="searchByEmail"
                  placeholder="Search by Email"
                  autoComplete="off"
                  aria-label="Enter Email"
                  aria-describedby="searchByEmail"
                  onChange={(el) => setSearchEmail(el.target.value)}
                  value={searchEmail}
                  onKeyDown={SearchWithEnter}
                />
                <span id="searchByEmailHint" className="sr-only">
                  Type a direct email address and press Enter or click the search button.
                </span>
                <div className="input-group-append">
                  <button
                    className="input-group-text btn btn-secondary"
                    aria-label="Search by Email"
                    id="basic-addon2"
                    onClick={(e) => SearchByEmail()}
                  >
                    <i className="bi bi-search" aria-hidden="true"></i>
                  </button>
                </div>
              </div>
            </div>
            <div className="OrgDropdown spacer-inline">
              <div role="toolbar" aria-label="Email list actions and filter options">
                {addBtnFlag && sharedObject.UserIdEmail.Name ? (
                  <button
                    className="btn btn-primary spacer-margin5"
                    aria-label={`Add email for ${sharedObject.UserIdEmail.Name || "this user"}`}
                    onClick={(el) => {
                      let o = {
                        id: sharedObject.UserIdEmail.Id,
                        name: sharedObject.UserIdEmail.Name,
                        domainName: sharedObject.UserIdEmail.Domain,
                        accountName: sharedObject.UserIdEmail.UserName,
                        firstName: sharedObject.UserIdEmail.FirstName,
                        userName: sharedObject.UserIdEmail.UserName,
                        lastName: sharedObject.UserIdEmail.LastName,
                        Flag: sharedObject.UserIdEmail.Flag,
                      };
                      if (sharedObject.UserIdEmail?.Flag === "orgEmails") {
                        SetSharedObject("orgActionObj", o);
                        $("#AddOrgEmailModal").modal("show");
                      } else if (
                        sharedObject.UserIdEmail?.Flag === "detailUser"
                      ) {
                        setEmailListObj(o);
                        $("#UsrEmailList").modal("show");
                      }
                    }}
                    data-toggle="modal"
                  >
                    Add
                  </button>
                ) : null}
                {userRole !== "SES ADMINISTRATOR" &&
                userRole !== "SYSTEMADMINISTRATOR" ? null : (
                  <Dropdown
                    value={selectedCustomer}
                    onChange={(e) => {
                      setSelectedCustomer(e.value);
                      CustomerIdSet(e.value?.id);
                    }}
                    options={customerObj}
                    optionLabel="name"
                    placeholder="Customers"
                    filter
                    className="form-control w-md2 spacer-margin5"
                    ariaLabel="Select customer"
                  />
                )}

                <Dropdown
                  value={customerOrgVal}
                  onChange={(e) => {
                    const selectedValue = e.value;
                    if (selectedValue) {
                      SelectUsersByOrgId(selectedValue); // or use id only, if needed
                    }
                  }}
                  options={orgObj.map((el) => ({
                    label: el.name,
                    value: `${el.id},${el.name}`,
                  }))}
                  placeholder="Organizations"
                  filter
                  className="form-control w-md2 spacer-margin5"
                  ariaLabel="Select organization"
                />
              </div>
            </div>

            {/* Advanced Search*/}
            <div className="spacer-inline">
              <button
                className="btn btn-primary ht-2"
                data-target="#advEmailSearchModal"
                data-toggle="modal"
                aria-haspopup="true"
                aria-expanded="false"
                aria-label="Open advanced search dialog"
              >
                Advanced Search
              </button>
            </div>
          </div>
        </header>
      </div>
      <section className="sp-margin1">
        {errDetailFlag ? (
          <div
            className={`alert alert-danger`}
            role="alert"
            aria-live="assertive"
            aria-atomic="true"
            dangerouslySetInnerHTML={{ __html: errDetailMsg }}
          />
        ) : null}
      </section>
      {showGridFlag ? (
        <section className="grid-layout">
          <div>
            <DataTable
              value={sharedObject.emailListObj}
              aria-label="Email List"
              paginator
              selectionPageOnly
              rows={10}
              rowsPerPageOptions={[10, 25, 50]}
              tableStyle={{ minWidth: "50rem" }}
              dataKey="id"
              paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
              currentPageReportTemplate="{first} to {last} of {totalRecords}"
              columnResizeMode="expand"
              resizableColumns
              selectionMode={"checkbox"}
              selection={selectedProducts}
              onSelectionChange={(e) => {
                setSelectedProducts(e.value);
              }}
              selectionAutoFocus={false}
              sortField="dtCreated"
              sortOrder={-1}
            >
              <Column selectionMode="multiple" className="w-s"></Column>
              <Column
                field="GridLinkCourse"
                header="Direct Email"
                className="truncate"
                sortable
              ></Column>
              {sharedObject.UserIdEmail?.Flag === "orgEmails" ||
              sharedObject.UserIdEmail?.Flag === "detailUser" ? null : (
                <Column
                  field="emailType"
                  header="Type"
                  className="w-md3"
                  sortable
                ></Column>
              )}
              <Column
                field="dtCreated"
                header="Date Created"
                className="w-md8"
                body={createdDate}
                sortable
              ></Column>
              <Column field="name" header="Name" sortable></Column>
              <Column
                field="directEmailPurpose"
                header="Purpose"
                className="w-md7"
                sortable
              ></Column>
              <Column
                field="keepMdn"
                header="Keep MDN"
                className="w-md1"
                sortable
              ></Column>
              <Column
                header="Send Dispatched MDN"
                body={MdnDispatchModeDisplay}
                sortable
              ></Column>
              <Column
                field="directTrustServiceDescriptionCode"
                header="Service Description"
                body={ServDesc}
                sortable
              ></Column>
            </DataTable>
          </div>
          <div className="paging">
            <div className="spacer-inline spacer-margin9">
              <button
                className="btn btn-outline-secondary"
                aria-label="Delete selected emails"
                onClick={(e) => {
                  SetCmfFlag(0);
                  setReasonInput("");
                  $("#ConfirmDelete").modal("show");
                }}
              >
                Delete
              </button>
            </div>
          </div>
          {processing && (
            <div 
                className="loader-container" 
                role="status" 
                aria-live="polite" 
                aria-atomic="true"
                aria-labelledby="grid-loader-id"
            >
                <div className="spinner" aria-hidden="true"></div>
                <div className="loading-text" id="grid-loader-id">{loadingText}</div>
            </div>
          )}
        </section>
      ) : (
        <section className="empty-grid" role="alert" aria-live="polite" aria-atomic="true">
          There are currently no results.
        </section>
      )}

      <div
        className="modal fade"
        id="ConfirmDelete"
        data-backdrop="static"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="ConfirmDeleteTitle"
        aria-modal="true"
        aria-describedby="ConfirmDeleteDesc"
      >
        <div className="modal-dialog ">
          <div className="modal-content">
            <div className="modal-header">
              <h3 className="modal-title" id="ConfirmDeleteTitle">Delete Confirmation</h3>
              <button
                type="button"
                className="close"
                aria-label="Close delete confirmation"
                onClick={CloseDeleteModal}
                disabled={processingDelete}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              {deleteFlag ? (
                <div>
                  <div className="bi-success-check">
                    <i
                      className="bi bi-check2-circle"
                      aria-hidden="true"
                    ></i>
                  </div>
                  <div id="ConfirmDeleteDesc" className="message-wrapper" role="alert" aria-live="polite">Deleted Successfully!</div>
                </div>
              ) : (
                //<p className={`alert alert-success`}>
                //  <ul className="sp-margin4">
                //    {selectedProducts.map((el) => (
                //      <li key={el.id}>{el.directEmailAddress}</li>
                //    ))}
                //  </ul>{" "}
                //  Successfully deleted.
                //</p>
                <>
                  {selectedProducts.length === 0 ? (
                    <div className="ctr sp-pad3" role="alert" aria-live="polite">
                      There was nothing selected to delete.
                    </div>
                  ) : (
                    <>
                      <div className="field-wrapper">
                        <div className="descript2-container">
                          Mailbox will be permanently deleted from your account.
                        </div>
                        <div className="spacer-margin7 line-s1">
                          <p id="deleteConfirmation">Are you sure you want to delete?</p>
                        </div>
                        <ul className="sp-margin4" aria-labelledby="deleteConfirmation">
                          {selectedProducts.map((el) => (
                            <li key={el.id}>{el.directEmailAddress}</li>
                          ))}
                        </ul>
                      </div>
                      <div className="modal-content-body sp-margin14">
                        <label htmlFor="deleteReason">Reason</label>
                        <input
                          type="text"
                          className="form-control"
                          id="deleteReason"
                          name="DeleteReason"
                          aria-describedby="deleteReasonDesc"
                          value={reasonInput}
                          onChange={(e) => setReasonInput(e.target.value)}
                        />
                        <div id="deleteReasonDesc" className="sp-margin3">
                          Please provide a reason why you are deleting the mailbox.
                        </div>
                        {sbmitFlag && reasonInput === "" ? (
                          <div className="alert alert-danger field-wrapper" role="alert" aria-live="assertive" aria-atomic="true">
                            Reason field is required.
                          </div>
                        ) : null}
                      </div>
                    </>
                  )}
                  {cmfFlag === 1 ? (
                    <p
                      className={`alert alert-danger`}
                      role="alert"
                      aria-live="assertive"
                      aria-atomic="true"
                      dangerouslySetInnerHTML={{
                        __html: cmfMessage,
                      }}
                    />
                  ) : null}
                </>
              )}
            </div>
            <div className="modal-footer">
              {selectedProducts.length === 0 || deleteFlag ? null : (
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={(e) => DeleteEmailComfirm()}
                  disabled={processingDelete}
                >
                  {processingDelete ? "Deleting..." : "Confirm"}
                </button>
              )}
              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={CloseDeleteModal}
                disabled={processingDelete}
              >
                {selectedProducts.length === 0 || deleteFlag
                  ? "Close"
                  : "Cancel"}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="SearchEmails">
        <div
          className="modal fade"
          id="advEmailSearchModal"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="advEmailSearchModalTitle"
          aria-describedby="advEmailSearchModalDesc"
          aria-modal="true"
          data-backdrop="static"
        >
          <div className="modal-dialog modal-dialog-slideout">
            <div className="modal-content">
              <div className="modal-header">
                <h2 className="modal-title spacer-inline" id="advEmailSearchModalTitle">
                  Advanced Search
                </h2>
                <button
                  type="button"
                  className="close"
                  aria-label="Close Advanced Email Search"
                  onClick={CloseAdvSearch}
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <form aria-label="Advanced Email Search Form">
                <div className="modal-body" >
                    <p id="advEmailSearchModalDesc" className="sr-only">
                      Use this form to search emails by customer, organization, date range, or name.
                    </p>
                  <div className="modal-content-body container">
                    {/*Customers SES Admins only*/}
                    {userRole !== "SES ADMINISTRATOR" &&
                    userRole !== "SYSTEMADMINISTRATOR" ? null : (
                      <div className="field-wrapper">
                        <label htmlFor="customer" className="sp-margin3">
                          Customer
                        </label>
                        <span className="filter-container dg-clr">
                          <input
                            className="form-control filter-sm"
                            type="search"
                            placeholder="Filter"
                            id="customerFilter"
                            name="CustomerFilter"
                            aria-label="Filter Customers"
                            onChange={(el) => {
                              filterVendors(el.target.value);
                            }}
                          />
                        </span>
                        <select
                          className="form-control"
                          size="4"
                          id="customer"
                          name="Customer"
                          aria-label="Select Customer"
                          onChange={(el) => {
                            CustomerIdSetSearch(el.target.value);
                          }}
                          value={customerCustValSearch}
                        >
                          <option value="">Select Customer</option>
                          {customerObjSearch?.map((el) => {
                            if (el.show)
                              return (
                                <option key={el.id} value={el.id}>
                                  {el.name}
                                </option>
                              );
                          })}
                        </select>
                      </div>
                    )}
                    {/*Organizations*/}
                    <div className="field-wrapper">
                      <label htmlFor="organization" className="sp-margin3">
                        Organization
                      </label>
                      {/*<i className="bi bi-asterisk rd-clr"></i>*/}
                      <span className="filter-container dg-clr">
                        <input
                          className="form-control filter-sm"
                          type="search"
                          placeholder="Filter"
                          id="organizationFilter"
                          name="OrganizationFilter"
                          aria-label="Filter Organizations"
                          onChange={(el) => filterOrgs(el.target.value)}
                        />
                      </span>
                      <select
                        className="form-control"
                        size="4"
                        id="organization"
                        name="Organization"
                        aria-label="Select Organization"
                        onChange={(el) => {
                          if (el.target.value !== "") {
                            SelectUsersByOrgIdSearch(el.target.value);
                          }
                        }}
                        value={customerOrgValSearch}
                      >
                        {orgObjSearch.length === 0 ? (
                          <option value="" disabled>No Results</option>
                        ) : (
                          <>
                            <option value="">Select Organization</option>
                            {orgObjSearch.map((el) => {
                              if (el.show)
                                return (
                                  <option key={el.id} value={el.id}>
                                    {el.name}
                                  </option>
                                );
                            })}
                          </>
                        )}
                      </select>
                      {!customerOrgValSearch && submitFlag ? (
                        <div className="alert alert-danger" role="alert" aria-live="assertive" aria-atomic="true">
                          Organization is Required!
                        </div>
                      ) : null}
                    </div>

                    {/*Email*/}
                    <div className="field-wrapper">
                      <label htmlFor="email">Email</label>
                      <input
                        type="text"
                        className="form-control"
                        id="email"
                        name="Email"
                        onChange={(el) => setAnswer("Email", el.target.value)}
                        value={answers?.Email}
                        aria-label="Enter Direct Email"
                        placeholder="Enter Direct Email"
                      />
                    </div>
                    <div className="field-wrapper">
                      {/* From Date*/}
                      <div className="spacer-margin5 spacer-inline w-md2">
                        <label htmlFor="fromDateInput">From Date</label>
                        <div
                          className="input-group date"
                          data-provide="datepicker"
                          // data-date-start-date="-7d"
                          data-date-end-date="0d"
                          onChange={(el) =>
                            setAnswer("FromDate", el.target.value)
                          }
                          value={answers?.FromDate}
                          data-date={answers?.FromDate}
                          aria-label="Select From Date"
                        >
                          <input
                            type="text"
                            className="form-control"
                            name="fromDateInput"
                            id="fromDateInput"
                            aria-label="Enter From Date"
                            onChange={(el) => handleDateChange("FromDate", el.target.value)}
                            value={answers?.FromDate ?? ""}
                          />
                          <div className="input-group-append">
                            <span className="input-group-text">
                              <i className="fas fa-calendar" aria-hidden="true"></i>
                            </span>
                          </div>
                        </div>
                      </div>
                      {/* To Date*/}
                      <div className="spacer-inline w-md2">
                        <label htmlFor="toDateInput">To Date</label>
                        <div
                          className="input-group date"
                          data-provide="datepicker"
                          // data-date-start-date="-7d"
                          data-date-end-date="0d"
                          aria-label="Select To Date"
                        >
                          <input
                            type="text"
                            className="form-control"
                            name="ToDate"
                            id="toDateInput"
                            onChange={(el) => {
                              handleDateChange("ToDate", el.target.value);
                            }}
                            value={answers?.ToDate ?? ""}
                            aria-label="Enter To Date"
                          />
                          <div className="input-group-append">
                            <span className="input-group-text" >
                              <i className="fas fa-calendar" aria-hidden="true"></i>
                            </span>
                          </div>
                        </div>
                      </div>

                    </div>

                    {/*First or Last Name*/}
                    <div className="field-wrapper">
                      <label htmlFor="name">Member Name</label>
                      <input
                        type="text"
                        className="form-control"
                        name="Name"
                        id="name"
                        onChange={(el) => setAnswer("Name", el.target.value)}
                        value={answers?.Name}
                        aria-label="Enter Name"
                      />
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-success"
                    onClick={(e) => AdvSearch()}
                  >
                    Search
                  </button>
                  <button
                    type="button"
                    className="btn btn-outline-secondary"
                    onClick={CloseAdvSearch}
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          </div>
          {processing && (
            <div 
                className="loader-container" 
                role="status" 
                aria-live="polite" 
                aria-atomic="true"
                aria-labelledby="search-loader-id"
            >
                <div className="spinner" aria-hidden="true"></div>
                <div className="loading-text" id="search-loader-id">{loadingText}</div>
            </div>
          )}
        </div>
      </div>
      <UserEmailList emailListObj={emailListObj} />
      <DetailsOrgEmails
        detailsEmail={detailsEmail}
        emailRefresh={emailRefresh}
      />
    </main>
  );
};

export default ListEmails;
